document.addEventListener("turbo:load", function () {
  const input = document.getElementById("pending-payment-search-input");
  const form = document.getElementById("pending-payment-search-form");

  if (!input || !form) return;

  if (input.value.trim() !== "") {
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }

  let timeout = null;

  input.addEventListener("input", function () {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      form.requestSubmit();
    }, 600);
  });
});